export default __webpack_public_path__ + "static/media/2d-motion.72fa57dc.gif";